export function Users(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 7C4.75 5.20507 6.20507 3.75 8 3.75C9.79493 3.75 11.25 5.20507 11.25 7C11.25 8.79493 9.79493 10.25 8 10.25C6.20507 10.25 4.75 8.79493 4.75 7ZM8 2.25C5.37665 2.25 3.25 4.37665 3.25 7C3.25 9.62335 5.37665 11.75 8 11.75C10.6234 11.75 12.75 9.62335 12.75 7C12.75 4.37665 10.6234 2.25 8 2.25ZM14 2.25C13.5858 2.25 13.25 2.58579 13.25 3C13.25 3.41421 13.5858 3.75 14 3.75C15.7949 3.75 17.25 5.20507 17.25 7C17.25 8.79493 15.7949 10.25 14 10.25C13.5858 10.25 13.25 10.5858 13.25 11C13.25 11.4142 13.5858 11.75 14 11.75C16.6234 11.75 18.75 9.62335 18.75 7C18.75 4.37665 16.6234 2.25 14 2.25ZM6 15.75C4.20507 15.75 2.75 17.2051 2.75 19C2.75 19.6904 3.30964 20.25 4 20.25H12C12.6904 20.25 13.25 19.6904 13.25 19C13.25 17.2051 11.7949 15.75 10 15.75H6ZM14.75 19C14.75 20.5188 13.5188 21.75 12 21.75H4C2.48122 21.75 1.25 20.5188 1.25 19C1.25 16.3766 3.37665 14.25 6 14.25H10C12.6234 14.25 14.75 16.3766 14.75 19ZM16 14.25C15.5858 14.25 15.25 14.5858 15.25 15C15.25 15.4142 15.5858 15.75 16 15.75H18C19.7949 15.75 21.25 17.2051 21.25 19C21.25 19.6904 20.6904 20.25 20 20.25H16C15.5858 20.25 15.25 20.5858 15.25 21C15.25 21.4142 15.5858 21.75 16 21.75H20C21.5188 21.75 22.75 20.5188 22.75 19C22.75 16.3766 20.6234 14.25 18 14.25H16Z"
        fill="currentColor"
      />
    </svg>
  );
}
